
import {
  defineComponent,
  SetupContext,
  onMounted,
  onUnmounted,
  onBeforeUnmount
} from "vue";
import { useStore } from "@/store";
import portfolioProjects, { PortfolioProject } from "@/scripts/portfolio";
import gsap from "gsap";

// selected class name
const selectedClass = "selected";

// definition of component
export default defineComponent({
  name: "PortfolioProjectCovers",
  props: {},
  setup(props, context: SetupContext) {
    // definition of Vuex
    const store = useStore();

    // definition of refs
    const coverItemRef: HTMLElement[] = [];
    const addCoverItemRef = (el: HTMLElement) => {
      coverItemRef.push(el);
    };

    // change the current project.
    const changeProject = (newIndex: number, oldIndex: number) => {
      // nop upon no selection change
      if (newIndex === oldIndex) return;

      const oldItem = coverItemRef[oldIndex];
      const newItem = coverItemRef[newIndex];

      const oldToYPercent = oldIndex < newIndex ? "-100%" : "100%";
      const newFromYPercent = oldIndex < newIndex ? "100%" : "-100%";

      oldItem.classList.remove(selectedClass);
      newItem.classList.remove(selectedClass);
      gsap
        .timeline()
        .to(oldItem, {
          y: oldToYPercent,
          ease: "power2.in",
          duration: 0.6,
          onComplete: () => {
            oldItem.style.visibility = "hidden";
          }
        })
        .fromTo(
          newItem,
          {
            y: newFromYPercent,
            visibility: "visible",
            delay: 0.2
          },
          {
            y: 0,
            ease: "power2.out",
            duration: 0.6,
            onComplete: () => {
              newItem.classList.add(selectedClass);
            }
          }
        );
    };

    // send project selection event
    const showProject = (selectedProject: PortfolioProject) => {
      context.emit("show-project", selectedProject);
    };

    // gets the current selected item index.
    const selectionChangeHandler = store.watch<number>(
      vuexState => {
        return vuexState.portfolioProjectIndex;
      },
      (newIndex: number, oldIndex: number) => {
        changeProject(newIndex, oldIndex);
      }
    );

    // lifecycle event
    onMounted(() => {
      const firstCover = coverItemRef[0];
      if (firstCover) {
        window.setTimeout(() => {
          firstCover.classList.add(selectedClass);
        }, 1500);
        gsap.fromTo(
          firstCover,
          {
            opacity: 0,
            visibility: "visible"
          },
          {
            opacity: 1,
            ease: "power2.out",
            duration: 0.8,
            delay: 1
          }
        );
      }
    });
    onBeforeUnmount(() => selectionChangeHandler());
    onUnmounted(() => {
      store.commit("setPortfolioProjectIndex", 0);
    });

    return {
      portfolioProjects,
      addCoverItemRef,
      showProject
    };
  }
});
